import React from 'react';

interface LogoProps {
  size?: number;
  showText?: boolean;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 32, showText = true, className = '' }) => (
  <span className={`af-logo ${className}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      role="img"
      aria-label="AssetFactory"
    >
      <rect width="36" height="36" rx="9" fill="#3157d5" />
      <path d="M10 25V12h8.5v3H13.3v2.4h4.5v2.9h-4.5V25H10Z" fill="white" />
      <path d="M20 25V12h6v3h-2.7v10H20Z" fill="#cbd6ff" />
    </svg>
    {showText && (
      <span style={{ color: '#18202b', fontSize: size * 0.45, fontWeight: 750, letterSpacing: '-0.035em', lineHeight: 1 }}>
        Asset<span style={{ color: '#3157d5' }}>Factory</span>
      </span>
    )}
  </span>
);

export default Logo;
